<ngx-simplebar class="responsiveScrollContainer">
  <div
    class="customersPage"
    *appHasPermission="{
      permissions: [permissions.allPermissions.CUSTOMER_OVERVIEW_READ],
    }"
  >
    <ngx-simplebar class="widget customersTable">
      @if (customersTimeout()) {
        <app-timeout></app-timeout>
      } @else if (customersLoading()) {
        <div class="h-full flex align-items-center justify-content-center widget">
          <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
        </div>
      } @else {
        <p-table
          [value]="customers()"
          [columns]="COLUMNS"
          class="p-2 fullTable tableHeaderAlignTop"
          [scrollable]="true"
        >
          <ng-template #emptymessage>
            <tr>
              <td colspan="8">
                {{ "common.no_entries" | translate }}
              </td>
            </tr>
          </ng-template>
          <ng-template #header>
            <tr>
              @for (column of COLUMNS; track column) {
                <th [ngClass]="{ name: column.field === 'label' }">
                  {{ column.header | translate }}
                </th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-customer let-column>
            <tr
              (click)="selectCustomer(customer)"
              [ngClass]="{
                'selected-customer': customer.id === selectedCustomer.id,
              }"
              class="pointer"
            >
              @for (column of COLUMNS; track column) {
                <td [ngClass]="{ name: column.field === 'label' }">
                  {{ customer[column.field] !== "0" && customer[column.field] !== 0 ? customer[column.field] : "" }}
                </td>
              }
            </tr>
          </ng-template>
        </p-table>
      }
    </ngx-simplebar>
    @if (selectedCustomer && selectedCustomer.id) {
      <ngx-simplebar class="widget faultTable">
        <app-gate-fault-table [gateFaults]="customersFacade.gateFaultState()"></app-gate-fault-table>
      </ngx-simplebar>
      <ngx-simplebar class="widget predictiveList">
        <app-service-list
          type="predictive"
          [asset]="{
            id: selectedCustomer.id,
            assetType: assetTypes.CUSTOMER,
          }"
        ></app-service-list>
      </ngx-simplebar>

      <app-kpi
        class="gateKpi"
        iconName="gate-0"
        label="Tore betriebsbereit"
        [source]="customersFacade.availableTotalGates()"
      ></app-kpi>

      <ngx-simplebar class="widget contractsList">
        <app-service-list
          type="contracts"
          [asset]="{
            id: selectedCustomer.id,
            assetType: assetTypes.CUSTOMER,
          }"
        ></app-service-list>
      </ngx-simplebar>
      <div class="widget map h-full">
        <app-customer-map [rootId]="selectedCustomer.id"></app-customer-map>
      </div>
    }
  </div>
</ngx-simplebar>
